import { render, staticRenderFns } from "./PostAudit.vue?vue&type=template&id=e31a5354&scoped=true"
import script from "./PostAudit.vue?vue&type=script&lang=js"
export * from "./PostAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31a5354",
  null
  
)

export default component.exports